<div class="standard-max-width">
    <div class="flex align-items-center justify-content-between mb-6 mt-2">
        <div class="flex align-items-center">
            <i class="material-icons text-2xl mr-2">description</i>
            <span class="text-2xl font-semibold">Manage Forms</span>
        </div>
        <div class="flex gap-2">
            <button pButton type="button" icon="pi pi-plus" label="Add Form" class="p-button-primary"
                (click)="openAddFormDialog()"></button>
        </div>
    </div>

    <hr class="my-4">

    <app-forms-view #formsView [orgId]="orgId" />
</div>

<p-dialog header="Add Form" [(visible)]="showAddFormDialog" [modal]="true" [style]="{
        'max-width': '700px',
    }" [draggable]="false" [resizable]="true" (onHide)="closeAddFormDialog()">
    @if (showAddFormDialog) {
    <app-crud-forms (onSuccess)="onAddFormSuccess()" />
    }
</p-dialog>